import type { DefinedInitialDataInfiniteOptions, InfiniteData, QueryKey, UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInfiniteQuery as useRqInfiniteQuery } from '@tanstack/react-query';

import type { APIError } from '@/core/lib/fetch';

const useInfiniteQuery = <TQueryFnData, TError = APIError, TData = InfiniteData<TQueryFnData>, TQueryKey extends QueryKey = QueryKey, TPageParam = unknown>(
  options: DefinedInitialDataInfiniteOptions<TQueryFnData, TError, TData, TQueryKey, TPageParam>,
): UseInfiniteQueryResult<TData, TError> => {
  return useRqInfiniteQuery<TQueryFnData, TError, TData, TQueryKey, TPageParam>(options);
};

export default useInfiniteQuery;
